import React, { useEffect, useState } from "react";
import "./App.css";
import MainRoutesComp from "./routes/routes";
import "bootstrap/dist/css/bootstrap.min.css";
import { EventEmitter } from "events";
import { useLocation } from "react-router-dom";
import "./i18n";
import BhashiniLoader from "./utils/BhashiniLoader";
import Cookies from "js-cookie";
export const event = new EventEmitter();

const LOGOUT_REDIRECT_URL = process.env.REACT_APP_LOGOUT_REDIRECT_URL;

function App() {

  const location = useLocation(); // hook to detect route change
  const [loginToken, setLoginToken] = useState(null);
  const [isAuthReady, setIsAuthReady] = useState(false);
  // Scroll to top on every route change
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [location.pathname]);

  // :white_check_mark: Logout handler
  React.useEffect(() => {
    const handleLogout = () => {
      Cookies.remove("access_token_admin");
      Cookies.remove("refresh_token");
      localStorage.clear();
      window.location.href = LOGOUT_REDIRECT_URL;
    };

    event.on("logout", handleLogout);
    return () => {
      event.off("logout", handleLogout);
    };
  }, []);

  const decodeToken = (token) => {
    try {
      const payload = token.split(".")[1];
      const decoded = JSON.parse(atob(payload));
      return decoded;
    } catch (err) {
      console.error("Invalid token", err);
      return null;
    }
  };



  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const urlToken = params.get("token");

      if (urlToken) {
        const hasRefreshed = sessionStorage.getItem("sp_token_refreshed");

        // ✅ Save token FIRST
        localStorage.setItem("access_token", urlToken);

        // ✅ Decode token
        try {
          const payload = JSON.parse(atob(urlToken.split(".")[1]));

          const role =
            payload.role === "User"
              ? "user"
              : payload.role?.toLowerCase();

          // ✅ FIX: stringify
          localStorage.setItem("type", JSON.stringify(role));

          const userData = {
            email: payload.email,
            role: role,
            user_level: payload.user_level,
            id: payload.id,
            user_category_main: payload.user_category_main,
            category_type: payload.category_type,
            sub_category_type: payload.sub_category_type,
            mobile: payload.mobile,
            first_name: payload.first_name,
            middle_name: payload?.middle_name,
            last_name: payload.last_name,
          };

          localStorage.setItem("user", JSON.stringify(userData));
        } catch (e) {
          console.error("Token decode failed", e);
        }

        // ✅ Refresh ONLY once
        if (!hasRefreshed) {
          sessionStorage.setItem("sp_token_refreshed", "true");
          window.location.reload();
          return; // ⛔ stop further execution
        }

        // ✅ After refresh → clean URL
        window.history.replaceState({}, document.title, window.location.pathname);
      }

      // ✅ Set token after everything
      const token =
        localStorage.getItem("access_token") ||
        localStorage.getItem("access_token_admin");

      setLoginToken(token);
      setIsAuthReady(true);
    } catch (err) {
      // storage blocked (private browsing, locked-down webview, cookies disabled, etc.)
      console.error("Auth init failed, storage unavailable", err);
      setLoginToken(null);
      setIsAuthReady(true);
    }
  }, []);



  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("clearStorage") === "true") {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      localStorage.removeItem("otp_mobile");

      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  // :rocket: Deep Link Handling (PATH BASED)
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    const isAndroid = /android/i.test(ua);
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

    const androidStore =
      "https://play.google.com/store/apps/details?id=com.khelotech.khelouk";

    const iosStore =
      "https://apps.apple.com/in/app/fit-uttarakhand/id6749542220";

    const currentUrl = window.location.href;
    const path = window.location.pathname;

    // :white_check_mark: Define restricted paths
    const restrictedPaths = ["/news", "/gallery", "/shorts"];

    const isRestricted = restrictedPaths.some((p) =>
      path.startsWith(p)
    );

    // :x: If not restricted → DO NOTHING
    if (!isRestricted) return;

    // :robot_face: ANDROID

    if (isAndroid) {
      let appOpened = false;

      const intentUrl =
        "intent://" +
        currentUrl.replace(/^https?:\/\//, "") +
        "#Intent;" +
        "scheme=https;" +
        "package=com.khelotech.khelouk;" +
        "end;";

      const handleVisibilityChange = () => {
        if (document.hidden) {
          appOpened = true;
        }
      };

      document.addEventListener(
        "visibilitychange",
        handleVisibilityChange
      );

      // Try opening app
      window.location.href = intentUrl;

      // Fallback to Play Store
      setTimeout(() => {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );

        if (!appOpened) {
          window.location.href = androidStore;
        }
      }, 2000);
    }

    // :green_apple: iOS

    else if (isIOS) {
      setTimeout(() => {
        window.location.href = iosStore;
      }, 1500);
    }
  }, [location.pathname]);

  return (
    <>
      <BhashiniLoader />
      <MainRoutesComp />
    </>
  );
}

export default App;